const defaultState = {
  data: [],
  isLoading: false,
  error: null,
  totalCount: 0,
  count: 0,
  page: 1,
  pageSize: 25,
  sortBy: 'timestamp',
  sortDirection: 'desc'
}

export default (state = defaultState, { type, data }) => {
  switch (type) {
    case 'SET_ACTIVITY_LOGS':
      // Handle both camelized API response and direct array data
      if (data && typeof data === 'object' && (data.activityLogs || data.activity_logs)) {
        // API response (check for both camelized and snake_case keys)
        const activityLogs = data.activityLogs || data.activity_logs
        return {
          ...state,
          data: Array.isArray(activityLogs) ? activityLogs : [],
          totalCount: data.totalCount || data.total_count || 0,
          count: data.count || 0,
          page: data.page || 1,
          pageSize: data.pageSize || data.page_size || 25,
          sortBy: data.sortBy || data.sort_by || 'timestamp',
          sortDirection: data.sortDirection || data.sort_direction || 'desc'
        }
      } else if (Array.isArray(data)) {
        // Direct array data (fallback)
        return {
          ...state,
          data: data,
          totalCount: data.length,
          count: data.length
        }
      } else {
        // Invalid data - return empty array
        return {
          ...state,
          data: [],
          totalCount: 0,
          count: 0
        }
      }
    case 'SET_ACTIVITY_LOGS_LOADING':
      return { ...state, isLoading: data }
    case 'SET_ACTIVITY_LOGS_ERROR':
      return { ...state, error: data }
    default:
      return state
  }
}
